module.exports = __webpack_public_path__ + "img/task.0524b9e5.svg";